import React from 'react';
import { CharacterCount as DNACharacterCount } from '@justgiving/dna-form';
import { InputProps } from 'src/helpers/forms';
import classNames from 'classnames';

interface Props {
  isTrimmed: boolean;
  maxLength: number;
  value: string;
  className: string;
}

class TextareaWithCharacterCount extends React.Component<Props & InputProps> {
  text: HTMLTextAreaElement;
  characterCount: typeof DNACharacterCount;

  componentDidMount() {
    const { maxLength, isTrimmed } = this.props;

    this.characterCount = new DNACharacterCount({
      el: this.text,
      maxLength,
      trimInput: isTrimmed,
    });
  }

  componentDidUpdate() {
    const { maxLength, isTrimmed, value } = this.props;

    if (value === '' && this.characterCount) {
      this.characterCount = new DNACharacterCount({
        el: this.text,
        trimInput: isTrimmed,
        maxLength,
      });
    }
  }

  componentWillUnmount() {
    delete this.characterCount;
  }

  render() {
    const { className, isTrimmed: _, ...input } = this.props;

    return (
      <textarea
        {...input}
        ref={c => {
          this.text = c as HTMLTextAreaElement;
        }}
        className={classNames(className, 'js-dna-character-count')}
      />
    );
  }
}

export default TextareaWithCharacterCount;



// WEBPACK FOOTER //
// ./src/components/dna/TextareaWithCharacterCount.tsx